import React, { Component } from 'react';

import Modal from '../../components/UI/Modal/Modal';
import Auxilliary from '../Auxilliary/Auxilliary';

const withErrorHandler = (WrappedComponent, axiosInstance) => {
	return class extends Component {
		constructor(props) {
			super(props);
			this.state = {
				error: null,
			};
		}

		componentWillMount() {
			this.reqInterceptor = axiosInstance.interceptors.request.use(
				(requestConfig) => {
					this.setState({ error: null });
					return requestConfig;
				}
			);
			this.resInterceptor = axiosInstance.interceptors.response.use(
				(res) => res,
				(error) => {
					this.setState({ error: error });
					return Promise.reject(error);
				}
			);
		}

		// In the child component componentDidMount we are reaching out to web, so these interceptop setup will be missed for very first request as componentDidMount of parent component is called after the creation life cycle of child
		componentDidMount() {
			// axios.interceptors.request.use
			// axios.interceptors.response.use
		}

		// We need to remove the interceptors at the time when componentWillUnmount beacuse, if we are using the withErrorHandler at multiple places in our application as a wrapper around the components then we will be having the multiple interceptors attached to the same axios instance even though the components having the old interceptors are no longer present.
		// So we need to remove the interceptors also when the component will unmount.
		componentWillUnmount() {
			axiosInstance.interceptors.request.eject(this.reqInterceptor);
			axiosInstance.interceptors.response.eject(this.resInterceptor);
		}

		errorConfirmedHandler = () => {
			this.setState({ error: null });
		};

		render() {
			// As inside constructor it is not good the use setState as it triggers a rerender and as we are still inside the constructor so the component has not been even rendered, but the setSate will trigger a rerender, as the componentWillMount is deprecated so the only place to write this code so that it can execute before the child component componentWillMount is the render method of this component.

			return (
				<Auxilliary>
					<Modal
						show={this.state.error}
						closeModal={this.errorConfirmedHandler}
					>
						{this.state.error ? this.state.error.message : null}
					</Modal>
					<WrappedComponent {...this.props} />
				</Auxilliary>
			);
		}
	};
};

export default withErrorHandler;
